import { render } from "./index.vue?vue&type=template&id=1ca7e4f3&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=1ca7e4f3&lang=scss&scoped=true"

import exportComponent from "/Users/yuhuiliu/code/btkcode/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca7e4f3"]])

export default __exports__